module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Vordemwald_AG-c2cf2f80a183ed9f88ab79b614de930f.svg";